import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopPrimary').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    overflowY: 'scroll',
    paddingBottom: '60px',
  },

  h1: {},

  heading: {
    fontWeight: '450',
    fontSize: '24px',
    textAlign: 'center',
    color: 'white',
    margin: '0',
  },

  caseListHeading: {
    display: 'block',
    width: '100%',
    fontSize: '18px',
    fontWeight: 450,
    lineHeight: '18px',
    textAlign: 'left',
    color: theme.colors.text.primary,
    margin: '0px',
    paddingTop: '24px',
  },

  headingWrapper: {
    width: '90%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },

  goToIcon: {
    position: 'absolute',
    display: 'flex',
    justifySelf: 'flex-start',
  },

  lootBoxWrapper: {
    width: '100%',
  },
}))
